import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["getHeaderTitle", "actionMetadata", "flowObjectTypeId", "actionId"];
import PropTypes from 'prop-types';
// @ts-expect-error untyped module customer-data-objects-ui-components
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import InAppNotificationActionMetadata from 'automation-ui-action-features/actions/in-app-notification/InAppNotificationActionMetadata';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import InAppNotificationActionSummary from 'automation-ui-action-features/actions/in-app-notification/InAppNotificationActionSummary';
import { jsx as _jsx } from "react/jsx-runtime";
function InAppNotificationActionCard(_ref) {
  let {
      getHeaderTitle,
      actionMetadata,
      flowObjectTypeId,
      actionId
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
    headerTitle: getHeaderTitle({
      actionId
    }),
    content: /*#__PURE__*/_jsx(InAppNotificationActionSummary, {
      actionMetadata: actionMetadata,
      flowObjectTypeId: flowObjectTypeId
    })
  }));
}
InAppNotificationActionCard.propTypes = {
  getHeaderTitle: PropTypes.func.isRequired,
  actionMetadata: PropTypes.instanceOf(InAppNotificationActionMetadata).isRequired,
  flowObjectTypeId: ObjectTypeIdType,
  actionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default InAppNotificationActionCard;